module.exports = __webpack_public_path__ + "img/greenBg.fd265b42.png";